<sharry-header></sharry-header>
<div class="gift-card">
  <div class="gift-card__hero">
    <div class="gift-card__hero__title">
      <h1>{{ 'shop.gift-card.title' | i18next }}</h1>
      <p>
        {{ 'shop.gift-card.subtitle' | i18next }}
        <a [routerLink]="'trip' | routeTranslate">
          {{ 'shop.gift-card.subtitle-anchor' | i18next }}
        </a>
      </p>
    </div>
    <img
      src="https://media.sharry.land/app/images/gift-card/image-gift-card-hero.webp"
      alt="hero" />
  </div>
  <form [formGroup]="form">
    <h2>
      {{ 'shop.gift-card.design' | i18next }}
    </h2>
    <div class="gift-card__design">
      @for (card of cards; track card; let i = $index) {
        <button
          class="gift-card__design__button"
          [ngStyle]="{ 'background-image': 'url(' + card.imgUrl + ')' }"
          [ngClass]="{ 'gift-card__design__button--active': card.active }"
          (click)="onCardClick(i)">
          ''
        </button>
      }
    </div>
    <!-- <h2>{{ 'shop.gift-card.gift-description' | i18next }}</h2>
    <mat-form-field class="gift-card__chose-phrase">
      <mat-select
        id="range"
        formControlName="description">
        @for (desc of descriptions; track desc) {
          <mat-option [value]="desc.key">
            {{ desc.value | i18next }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field> -->
    <h2>{{ 'shop.gift-card.amount' | i18next }}</h2>
    <mat-button-toggle-group [value]="form.get('amount')?.value">
      @for (amount of amounts; track amount; let last = $last) {
        <mat-button-toggle
          [value]="amount"
          (click)="setAmount(amount)"
          >{{ amount | currency: 'EUR' : 'symbol-narrow' : '0.0' }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>

    <!-- <h2>{{ 'shop.gift-card.ship' | i18next }}</h2>
    <mat-radio-group
      class="gift-card__radio"
      color="primary"
      aria-label="Select an option"
      formControlName="ship">
      <mat-radio-button
        checked="true"
        [value]="0"
        >{{ 'shop.gift-card.mail-recipient' | i18next }}</mat-radio-button
      >
      <mat-radio-button [value]="1">{{ 'shop.gift-card.mail-sender' | i18next }}</mat-radio-button>
    </mat-radio-group> -->

    <h2>{{ 'shop.gift-card.recipient' | i18next }}</h2>
    <div class="gift-card__recipient">
      <mat-form-field>
        <input
          id="name"
          formControlName="recipientName"
          matInput
          autocomplete="recipientName"
          [placeholder]="'shop.gift-card.recipient-name-placeholder' | i18next" />
      </mat-form-field>
      <mat-form-field>
        <input
          id="mail"
          formControlName="recipientMail"
          matInput
          autocomplete="recipientMail"
          [placeholder]="'shop.gift-card.recipient-mail-placeholder' | i18next" />
      </mat-form-field>
    </div>
    <h2>
      {{ 'shop.gift-card.message' | i18next }}
    </h2>
    <mat-form-field>
      <textarea
        #autosize="cdkTextareaAutosize"
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="5"
        formControlName="message"
        [placeholder]="'shop.gift-card.message-placeholder' | i18next"></textarea>
    </mat-form-field>
    <div class="gift-card__last-row">
      <div class="gift-card__last-row__sender">
        <h2>{{ 'shop.gift-card.sender' | i18next }}</h2>
        <mat-form-field>
          <input
            id="name"
            formControlName="sender"
            matInput
            autocomplete="recipientName"
            [placeholder]="'shop.gift-card.sender-placeholder' | i18next" />
        </mat-form-field>
      </div>
      <div class="gift-card__last-row__when">
        <h2>{{ 'shop.gift-card.when' | i18next }}</h2>
        <mat-form-field>
          <input
            matInput
            formControlName="when"
            [min]="today"
            [matDatepicker]="picker" />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker">
            <sharry-icon
              name="calendar-blank"
              matDatepickerToggleIcon></sharry-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="gift-card__form-result">
    <div
      class="gift-card__form-result__image"
      [ngStyle]="{
        'background-image':
          'url(https://media.sharry.land/app/images/gift-card/0' + (form?.get('design').value + 1) + '-gift-card.webp)',
      }">
      <h3>{{ form.get('amount')?.value | currency: 'EUR' : 'symbol-narrow' : '0.0' }}</h3>
      <div class="gift-card__form-result__image__circle"></div>
    </div>
    <div class="gift-card__form-result__text">
      <h3>{{ form.get('amount')?.value | currency: 'EUR' : 'symbol-narrow' : '0.2' }}</h3>
      <button
        class="gift-card__preview mat-mdc-button rounded"
        (click)="onDownloadPdf()">
        <sharry-icon
          registryName="gift"
          svgClass="svg-icon"></sharry-icon>
        {{ 'shop.gift-card.preview-pdf' | i18next }}
      </button>
      <button
        mat-flat-button
        color="rainbow"
        class="sharry-xl rounded"
        [disabled]="form?.invalid"
        (click)="addToCart()">
        {{ 'shop.gift-card.add-to-cart' | i18next }}
      </button>
      <a [routerLink]="'terms' | routeTranslate">{{ 'shop.gift-card.terms-and-conditions' | i18next }}</a>
    </div>
  </div>
  <div class="gift-card__faq">
    <div class="gift-card__faq__section">
      <h3 class="bold">{{ 'shop.gift-card.how-works.question' | i18next }}</h3>
      <p>{{ 'shop.gift-card.how-works.answer' | i18next }}</p>
    </div>
    <div class="divider"></div>
    <div class="gift-card__faq__section">
      <div class="gift-card__faq__section--accordion">
        <h3 class="bold">{{ 'shop.gift-card.questions.question' | i18next }}</h3>
        <p>
          {{ 'shop.gift-card.questions.answer' | i18next }}
          <a [routerLink]="'faq' | routeTranslate">
            {{ 'shop.gift-card.questions.answer-anchor' | i18next }}
          </a>
        </p>
      </div>
      <div class="gift-card__faq__section--accordion">
        <mat-accordion
          displayMode="flat"
          [multi]="true">
          @for (f of [1, 2, 3, 4]; track f) {
            <mat-expansion-panel class="sharry-flat-panel">
              <mat-expansion-panel-header>
                <mat-panel-title> {{ 'shop.gift-card.accordion.question-' + f | i18next }}</mat-panel-title>
              </mat-expansion-panel-header>
              <p>{{ 'shop.gift-card.accordion.answer-' + f | i18next }}</p>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </div>
  </div>
  <sharry-contact-us-button></sharry-contact-us-button>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
